export default function CtaSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6 text-center">
        {/* Image */}
        <div className="rounded-2xl overflow-hidden mb-10 md:mb-14 mx-auto max-w-[700px]">
          <img
            src="https://readdy.ai/api/search-image?query=A%20beautifully%20styled%20fashion%20flat%20lay%20with%20mixed%20textiles%20and%20accessories%20on%20a%20warm%20terracotta%20surface%2C%20golden%20hour%20sunlight%2C%20elegant%20editorial%20photography%2C%20rich%20earthy%20tones%20with%20touches%20of%20metallic%20accents%2C%20no%20text%20or%20logos&width=1400&height=600&seq=cta-new-image&orientation=landscape"
            alt="Explore the latest VigorBuy Spreadsheet products"
            title="VigorBuy Spreadsheet - Browse Now"
            className="w-full h-auto object-cover"
          />
        </div>

        {/* Text */}
        <p className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 leading-tight mb-10 md:mb-12 max-w-[650px] mx-auto">
          Get the <span className="italic font-light text-foreground-500">latest</span> VigorBuy spreadsheet with verified sellers and safe buying guides.
        </p>

        {/* CTA */}
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-block px-10 py-4 bg-foreground-900 text-white font-semibold text-sm rounded-full hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
        >
          Buy It Now
        </a>
      </div>
    </section>
  );
}